// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"411":"1a5a93cb","621":"14c30a4d","649":"20733440"}[chunkId] + ".chunk.js";
};